import { render, staticRenderFns } from "./GetStockItems.vue?vue&type=template&id=c03e2312&scoped=true&"
import script from "./GetStockItems.vue?vue&type=script&lang=js&"
export * from "./GetStockItems.vue?vue&type=script&lang=js&"
import style0 from "./GetStockItems.vue?vue&type=style&index=0&id=c03e2312&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03e2312",
  null
  
)

export default component.exports